import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const materialDownloadTasksSliceName = "materialDownloadTasks";

type TaskId = string;

export interface MaterialDownloadTask {
  taskId: TaskId;
  createdAt: number;
  total: number;
  success: number;
  failed: number;
}

export interface MaterialDownloadTasksState {
  taskLookup: Record<TaskId, MaterialDownloadTask>;
}

const initialState: MaterialDownloadTasksState = {
  taskLookup: {},
};

const materialDownloadTasksSlice = createSlice({
  name: materialDownloadTasksSliceName,
  initialState,
  reducers: {
    addMaterialDownloadTask(state: MaterialDownloadTasksState, action: PayloadAction<{ taskId: TaskId; total: number }>) {
      state.taskLookup[action.payload.taskId] = {
        taskId: action.payload.taskId,
        createdAt: new Date().getTime(),
        total: action.payload.total,
        success: 0,
        failed: 0,
      };
    },
    registerFinishedMaterialDownload(state: MaterialDownloadTasksState, action: PayloadAction<{ taskId: TaskId; success: boolean }>) {
      const task = state.taskLookup[action.payload.taskId];
      if (task) {
        if (action.payload.success) {
          task.success++;
        } else {
          task.failed++;
        }
      }
    },
    removeMaterialDownloadTask(state: MaterialDownloadTasksState, action: PayloadAction<TaskId>) {
      // delete the key to exclude it from Object.keys() and Object.entries()
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete state.taskLookup[action.payload];
    },
  },
});

export interface MaterialDownloadTasksRootState {
  [materialDownloadTasksSliceName]: MaterialDownloadTasksState;
}

export const selectMaterialDownloadTasks = (state: MaterialDownloadTasksRootState) => state[materialDownloadTasksSliceName];

export const { addMaterialDownloadTask, registerFinishedMaterialDownload, removeMaterialDownloadTask } = materialDownloadTasksSlice.actions;
export const materialDownloadTasksReducer = materialDownloadTasksSlice.reducer;
